var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaveActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9063 3.85545L6.81563 1.15027C6.29375 0.920827 5.71563 0.954133 5.21875 1.25019L3.78437 2.09764C3.4375 2.30487 3.4125 2.87847 3.7375 3.12642L8.32813 6.62354L5.25 8.48497L3.43125 7.5265C3.15938 7.38218 2.84375 7.38958 2.57813 7.54871L1.57188 8.14451C1.28125 8.31844 1.20313 8.76622 1.41563 9.05857L3.7 12.2152C3.89063 12.478 4.16875 12.6297 4.45938 12.6297H8.7625C8.91875 12.6297 9.07188 12.5853 9.20938 12.5039L17.7375 7.45619C19.1906 6.59394 20.3156 5.11367 20.8875 3.31145C21.1844 2.37889 20.6 1.37971 19.7563 1.37971H17.9625C17.3312 1.37971 16.7063 1.55734 16.1438 1.8978L12.9063 3.85545ZM1 17.3666C1 18.0216 1.44687 18.5508 2 18.5508H20C20.5531 18.5508 21 18.0216 21 17.3666C21 16.7115 20.5531 16.1823 20 16.1823H2C1.44687 16.1823 1 16.7115 1 17.3666Z",
    fill: "#2563eb",
    stroke: "#2563eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveActive);
export default __webpack_public_path__ + "static/media/leave-active.5515fd3f72822b0d83bf0a33484e9cd8.svg";
export { ForwardRef as ReactComponent };